import React, { useCallback, useMemo } from "react";
import { FieldProps } from "react-jsonschema-form";
import DatePickerGroup from "../../witadmin/CRUD/Common/DatePickerGroup";
import { addDays, format } from "date-fns";
import { defineMessages, FormattedMessage } from "react-intl";

const messages = defineMessages({
  from: {
    id: "default.startDate",
    description: "startDate",
    defaultMessage: "startDate",
  },
  to: {
    id: "default.endDate",
    description: "endDate",
    defaultMessage: "endDate",
  },
});

export function DateRangePicker({
  formData,
  rawErrors,
  onChange,
  disabled,
  id,
  schema,
}: FieldProps) {
  const handleChangeDate = useCallback(
    (data, type) => {
      onChange({ ...formData, [type]: data.value ? data.value.concat("T00:00:00+00:00") : "" });
    },
    [formData, onChange]
  );
  const minDate = useMemo(() => {
    if (formData?.from) {
      const date = addDays(new Date(formData?.from), 1);
      return format(date, "yyyy-MM-dd");
    }
  }, [formData]);
  return (
    <div>
      <label>
        <FormattedMessage {...messages.from} />
      </label>
      <DatePickerGroup
        formValues={{ startDate: formData?.from, endDate: formData?.to }}
        hasErrors={rawErrors}
        onChange={data => {
          handleChangeDate(data, "from");
        }}
        disabled={disabled}
        value={formData?.from}
        field={{
          fieldName: id,
          selectsStart: true,
          isRange: true,
          startField: "startDate",
          endField: "endDate",
        }}
      />
      <label>
        <FormattedMessage {...messages.to} />
      </label>
      <DatePickerGroup
        formValues={{ startDate: formData?.from, endDate: formData?.to }}
        hasErrors={rawErrors}
        onChange={data => {
          handleChangeDate(data, "to");
        }}
        disabled={disabled}
        value={formData?.to}
        field={{
          fieldName: id,
          selectsStart: true,
          isRange: true,
          startField: "startDate",
          endField: "endDate",
        }}
        minDate={minDate}
      />
    </div>
  );
}
